import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';

export default class LpClassic extends BaseLP {
    subjectToPermanent() {
        const constraints = {
            players: this.exec('player', {}, ''),
            salary: this.exec('salary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, ''),
            positions: this.exec('positions', {}, ''),
            teams: this.exec('team', {}, ''),
            limitPositions: this.exec('limitPositions', {}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {}, ''),
        };

        return {...constraints};
    }
    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('createdLineups', {}, ''),
            nhlTeamStacking: this.exec('nhlTeamStacking', {}, ''),
            nhlLegacyTeamStacking: this.exec('nhlLegacyTeamStacking', {}, ''),
            nhlNameStacking: this.exec('nhlNameStacking', {}, ''),
            nhlNonControlledStacking: this.exec('nhlNonControlledStacking', {}, ''),
            exposureMax: this.exec('exposureMax', {}, ''),
            exposureMin: this.exec('exposureMin', {}, ''),
            flexExposureMax: this.exec(
                'flexMaxExposure',
                {
                    flexPositionsQuantity: 2,
                },
                '',
            ),
            teamExposureMax: this.exec(
                'teamExposureMax',
                {
                    minPlayersQuantityToIdentifyUsedTeam: Const.NHL_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM,
                },
                [],
            ),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
